/* Solza-filtergedrag bovenop de vendor-filterflow (storefont-filters.js
   vervangt bij elke filterwijziging de hele sectie; collection.js opent
   en sluit het filterscherm via --m-translate-x en display).

   Dit bestand regelt wat de vendor-flow niet kan:
   1. "Toon alle N opties" per filtergroep (en die staat onthouden).
   2. Open/dicht-staat van de accordeongroepen en het open filterscherm
      herstellen na een sectie-vervanging, zodat het scherm op mobiel
      open blijft terwijl het resultaataantal in de bevestigknop
      meebeweegt.
   3. Scroll-lock op de achtergrond zolang het filterscherm open is.
   4. Bevestigknop en Escape sluiten het scherm; het kruisje is ook met
      het toetsenbord te bedienen.
   5. Een aria-live-melding met het nieuwe resultaataantal na elke
      filterwijziging. */
(function () {
  if (window.__solzaFiltersInit) return;
  window.__solzaFiltersInit = true;

  var SECTION = '.facest-filters-section';

  /* -- aria-live-regio (buiten de sectie, overleeft vervangingen) -- */
  var liveRegion = document.createElement('div');
  liveRegion.setAttribute('aria-live', 'polite');
  liveRegion.className = 'm:visually-hidden';
  document.addEventListener('DOMContentLoaded', function () {
    document.body.appendChild(liveRegion);
  });
  if (document.readyState !== 'loading') document.body.appendChild(liveRegion);

  function announceResults(root) {
    var counter = root.querySelector('.m-collection-toolbar__total');
    if (counter) liveRegion.textContent = counter.textContent.trim();
  }

  /* -- scroll-lock -- */
  function lockScroll(on) {
    document.documentElement.classList.toggle('solza-no-scroll', !!on);
  }

  function closeDrawer() {
    var closeBtn = document.querySelector(SECTION + ' .m-sidebar__close');
    if (closeBtn) closeBtn.dispatchEvent(new Event('click', { bubbles: true }));
    lockScroll(false);
  }

  /* -- klikgedrag -- */
  document.addEventListener('click', function (e) {
    var more = e.target.closest('[data-filter-more]');
    if (more) {
      var list = more.parentElement.querySelector('.solza-filter-options');
      if (list) list.classList.add('is-expanded');
      more.remove();
      return;
    }
    if (e.target.closest('[data-filter-apply]')) {
      closeDrawer();
      return;
    }
    if (e.target.closest('.m-filter-button')) {
      /* het bottom sheet bestaat alleen onder 768px; vanaf tablet
         staat de zijbalk vast naast het grid */
      if (window.innerWidth < 768) lockScroll(true);
      return;
    }
    if (e.target.closest(SECTION + ' .m-sidebar__close')) {
      lockScroll(false);
      return;
    }
    /* tikken op de donkere achtergrond (het overlay-element zelf) */
    var sidebar = e.target.closest(SECTION + ' .m-sidebar');
    if (sidebar && e.target === sidebar) lockScroll(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openSection = document.querySelector(SECTION + '.sidebar-open');
      if (openSection) closeDrawer();
      return;
    }
    if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest(SECTION + ' .m-sidebar__close')) {
      e.preventDefault();
      e.target.closest('.m-sidebar__close').dispatchEvent(new Event('click', { bubbles: true }));
      lockScroll(false);
    }
  });

  /* -- staat aflezen uit de oude sectie en terugzetten op de nieuwe -- */
  function readState(oldSection) {
    var state = { open: [], closed: [], expanded: [], drawerOpen: false };
    oldSection.querySelectorAll('[data-solza-acc]').forEach(function (acc) {
      var content = acc.querySelector('.solza-acc__content');
      if (!content || !content.id) return;
      (acc.classList.contains('is-open') ? state.open : state.closed).push(content.id);
      var list = acc.querySelector('.solza-filter-options.is-expanded');
      if (list) state.expanded.push(content.id);
    });
    state.drawerOpen = oldSection.classList.contains('sidebar-open');
    return state;
  }

  function applyState(newSection, state) {
    state.open.forEach(function (id) { setAccOpen(newSection, id, true); });
    state.closed.forEach(function (id) { setAccOpen(newSection, id, false); });
    state.expanded.forEach(function (id) {
      var content = newSection.querySelector('[id="' + id + '"]');
      if (!content) return;
      var list = content.querySelector('.solza-filter-options');
      if (list) list.classList.add('is-expanded');
      var more = content.querySelector('[data-filter-more]');
      if (more) more.remove();
    });
    if (state.drawerOpen && window.innerWidth < 768) {
      reopenDrawer(newSection);
    } else if (state.drawerOpen) {
      lockScroll(false);
    }
    announceResults(newSection);
  }

  function setAccOpen(root, contentId, open) {
    var content = root.querySelector('[id="' + contentId + '"]');
    if (!content) return;
    var acc = content.closest('[data-solza-acc]');
    if (!acc) return;
    acc.classList.toggle('is-open', open);
    var btn = acc.querySelector('.solza-acc__trigger');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  /* Het filterscherm zonder animatie opnieuw openen: de vervangen
     sectie komt dicht uit de server, dus bij een open scherm zou er
     anders elke wijziging een schuifanimatie afspelen. */
  function reopenDrawer(section) {
    var sidebar = section.querySelector('.m-sidebar');
    var content = section.querySelector('.m-sidebar__content');
    if (!sidebar || !content) return;
    content.style.transitionDuration = '0s';
    sidebar.style.transitionDuration = '0s';
    sidebar.style.display = 'block';
    sidebar.style.setProperty('--m-bg-opacity', '0.5');
    content.style.setProperty('--m-translate-x', '0');
    section.classList.add('sidebar-open');
    lockScroll(true);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        content.style.removeProperty('transition-duration');
        sidebar.style.removeProperty('transition-duration');
      });
    });
  }

  /* -- sectie-vervangingen volgen -- */
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      var removed = null;
      var added = null;
      m.removedNodes.forEach(function (n) {
        if (n.nodeType === 1 && n.matches && n.matches(SECTION)) removed = n;
      });
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1 && n.matches && n.matches(SECTION)) added = n;
      });
      if (removed && added) applyState(added, readState(removed));
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
